import { render, staticRenderFns } from "./UnitProductCreate.vue?vue&type=template&id=10ea7406&scoped=true"
import script from "./UnitProductCreate.vue?vue&type=script&lang=js"
export * from "./UnitProductCreate.vue?vue&type=script&lang=js"
import style0 from "./UnitProductCreate.vue?vue&type=style&index=0&id=10ea7406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ea7406",
  null
  
)

export default component.exports